import cx from 'classnames';
import {VendorImages} from '~/CreateFabricInvitation/routes/EventGifting/components/VendorImages/VendorImages';
import {useEventGiftingClassifiedCategory} from '~/CreateFabricInvitation/routes/EventGifting/useEventGiftingClassifiedCategory';
import {useIsLargeAndUp} from '~/common/hooks/useMatchQuery';
import {Typography} from '~library/atoms/Typography';

import './Header.sass';

export const Header = ({inPreviewStep = false}) => {
  const isLargeAndUp = useIsLargeAndUp();

  const {isWeddingEvent, isBabyEvent, isFuneralEvent} = useEventGiftingClassifiedCategory();

  let title = 'Add a wishlist';
  let subtitle = 'Take the guesswork out of gifting by linking out to a wishlist. ';

  if (isWeddingEvent || isBabyEvent) {
    title = 'Add a registry or wishlist';
    subtitle = 'Link out to up to three different registries. ';
  }

  if (isFuneralEvent) {
    title = 'Add a special cause';
    subtitle = 'Let guests know how they can show their support. ';
  }

  return (
    <div className="event-gifting__header">
      <div className="event-gifting__header__title_wrapper">
        <Typography
          variant="header4"
          className={cx('event-gifting__header__title', {
            'event-gifting__variant__header__title__preview-step': inPreviewStep,
          })}
        >
          {title}
        </Typography>
        {inPreviewStep && isLargeAndUp && <VendorImages />}
      </div>
      {!inPreviewStep && <Typography variant="paragraph2">{subtitle}</Typography>}
    </div>
  );
};
